import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChange } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AccountService } from './../../services/services.module';
import { GlobalValidators } from './../../utils/validators';
import { GlobalConfig } from '../../shared/global-config';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-forgot-password-sign-up',
  templateUrl: './forgot-password-sign-up.component.html',
  styleUrls: ['./forgot-password-sign-up.component.scss'],
})
export class ForgotPasswordSignUpComponent implements OnInit, OnChanges {
  passwordResetErrors: string[];
  passwordResetInProgress: boolean;
  sentVeryficationInProgress: boolean;
  verifyingCodeInProgress: boolean;
  contactAdministratorInProgress: boolean;
  @Input() fields;
  @Output() changeNIC = new EventEmitter();
  sendVerificationCodeFG: FormGroup;
  verifySignupFG: FormGroup;
  passwordResetFG: FormGroup;
  verificationFields: any;
  hideVerificationProcess: boolean;
  sentVerification: boolean;
  signUpFormErrors = false;
  resetOnError = false;
  resetPassword: boolean;
  successfulMsg: boolean;
  verifySignupErrors: any;
  sendVerificationCodeErrors: any;
  showRecaptchaOnPwReset = true;
  requestCaptchaKey: any;
  masterData = {};
  verificationExceeded: boolean;
  constructor(private fb: FormBuilder, private accountService: AccountService, private router: Router, public translate: TranslateService) { }

  ngOnInit() {
    if (!this.fields) {
      this.bindSendVerificationForm(this.fields);
      this.bindVerifySignup(this.fields);
      this.bindPasswordReset(this.fields);
    }
  }

  ngOnChanges(changes: { [propKey: string]: SimpleChange }) {
    if (changes['fields']) {
      if (!!this.fields) {
        this.bindSendVerificationForm(this.fields);
        this.bindVerifySignup(this.fields);
        this.bindPasswordReset(this.fields);
      }
    }
  }
  bindSendVerificationForm(fields?) {
    if (!fields) {
      fields = { nic: '', passport: '' };
    }
    this.sendVerificationCodeFG = this.fb.group({
      nic: [fields.nic || '', []],
      passport: [fields.passport || '', []],
      brn: [fields.brn || '', []],
      mobilePhoneCountryCode: [GlobalConfig.countryCode === 'bn' ? '880' : '94', []],
      mobilePhoneAreaCode: ['', [GlobalValidators.pattern(/\d{3}/i), GlobalValidators.required]],
      mobilePhoneNumber: [
        '',
        [
          GlobalValidators.requireIfTrue('mobilePhoneAreaCode'),
          GlobalValidators.pattern(GlobalConfig.countryCode === 'bn' ? /\d{7}/i : /\d{6}/i),
        ],
      ],
      email: ['', [GlobalValidators.email, GlobalValidators.required]],
    });
    this.sendVerificationCodeFG.valueChanges.subscribe((val) => {
      this.sentVerification = false;
      this.sendVerificationCodeErrors = [];
      this.verificationExceeded = false;
      this.sendVerificationCodeErrors = [];
      this.verifySignupErrors = [];
      this.verifySignupFG.get('verificationCode').reset();
    });
    this.sendVerificationCodeFG.get('email').valueChanges.subscribe((val) => {
      this.verifySignupFG.get('email').setValue(val);
      this.passwordResetFG.get('email').setValue(val);
    });
  }
  bindVerifySignup(fields?) {
    if (!fields) {
      fields = { nic: '', passport: '', brn: '' };
    }
    this.verifySignupFG = this.fb.group({
      nic: [fields.nic || '', []],
      passport: [fields.passport || '', []],
      email: ['', []],
      brn: [fields.brn || '', []],
      verificationCode: ['', [Validators.required]],
    });
  }
  bindPasswordReset(fields?) {
    if (!fields) {
      fields = { nic: '', passport: '', brn: '' };
    }
    this.passwordResetFG = this.fb.group(
      {
        nic: [fields.nic || '', []],
        passport: [fields.passport || '', []],
        brn: [fields.brn || '', []],
        // captchaResponse: [''],
        // captchaText: [, Validators.required],
        email: ['', []],
        captchaAttempts: [1],
        password: ['', [Validators.required, GlobalValidators.password()]],
        confirmPassword: ['', [Validators.required]],
        verificationCode: [this.verifySignupFG.get('verificationCode').value || '', [Validators.required]],
      },
      {
        validator: GlobalValidators.misMatchPasswords('password', 'confirmPassword'),
      }
    );
  }

  async onSendSignupVerificationCodes(form) {
    this.verificationExceeded = false;
    this.sendVerificationCodeErrors = [];
    this.verifySignupErrors = [];
    if (form.invalid) {
      this.signUpFormErrors = true;
      return;
    }

    try {
      this.sentVeryficationInProgress = true;
      await this.accountService.sendPasswordReset(form.value);
      this.sentVerification = true;
      this.sentVeryficationInProgress = false;
      this.sendVerificationCodeErrors = [];
    } catch (e) {
      this.sentVeryficationInProgress = false;
      if (e.error.message.indexOf('Details you Entered are incorrect. Please contact administrator.') >= 0) {
        this.sendVerificationCodeErrors = [
          'Details you have entered do not match with our records, please click the below button to contact the Administrator or try again.',
        ];
      } else if (e.error.message.indexOf('Cannot find a portal account to proceed') >= 0) {
        this.sendVerificationCodeErrors = ['Email you have entered is not registered in our system'];
      } else {
        this.sendVerificationCodeErrors = ['Maximum verification attempts exceeded'];
      }
    }
  }
  onVerifySignup(form) {
    if (form.invalid) {
      return;
    }
    this.verifyingCodeInProgress = true;
    this.passwordResetFG.get('verificationCode').setValue(form.value.verificationCode);
    this.accountService
      .verifySignUpCode(form.value)
      .then((profile) => {
        this.verifySignupErrors = [];
        this.verifyingCodeInProgress = false;
        this.hideVerificationProcess = true;
        this.resetPassword = true;
      })
      .catch((e) => {
        if (e.error.message.indexOf('This account has temporarily blocked. Maximum verification attempts exceeded.') >= 0) {
          this.verifySignupErrors = ['This account has temporarily blocked. Maximum verification attempts exceeded.'];
          this.verificationExceeded = true;
        } else {
          this.verifySignupErrors = ['Incorrect verification code'];
        }
        this.verifyingCodeInProgress = false;
      });
  }
  passwordReset(form) {
    if (form.invalid) {
      return;
    }
    // console.log(form.value);
    this.resetOnError = false;
    this.passwordResetInProgress = true;
    // this.passwordResetFG
    //   .get('captchaResponse')
    //   .setValue(this.requestCaptchaKey + ',' + this.passwordResetFG.get('captchaText').value.toLowerCase());
    this.accountService
      .resetPassword(form.value)
      .then(() => {
        this.passwordResetErrors = [];
        this.passwordResetInProgress = false;
        this.router.navigate(['/']);
      })
      .catch((e) => {
        this.resetOnError = true;
        // this.passwordResetFG.get('captchaText').setValue(null);
        this.passwordResetInProgress = false;
        // if (!!e.json() && !!e.json().message && e.json().message.indexOf('CAPTCHA') >= 0) {
        //   this.passwordResetErrors = ['The CAPTCHA wasn&rsquo;t entered correctly. Go back and try it again.'];
        // }

        if (!!e.json() && !!e.json().error_description && e.json().error_description.indexOf('locked') >= 0) {
          this.passwordResetErrors = [e.json().error_description];
        } else {
          this.passwordResetErrors = [
            'Unable to Reset Password, please contact us via email to <a href="mailto:info&#64;calbd.com.bd">info&#64;calbd.com.bd</a> to proceed further.',
          ];
        }
      });
  }
  changeNic(event) {
    this.changeNIC.emit();
  }
  contactAdmin() {
    this.contactAdministratorInProgress = true;
    this.accountService
      .requestResetPassword({
        nic: this.fields.nic,
        passport: this.fields.passport,
      })
      .then(() => {
        this.hideVerificationProcess = true;
        this.contactAdministratorInProgress = false;
        this.successfulMsg = true;
      });
  }

  goToLogin() {
    this.router.navigate(['/signin']);
  }
  // submitPwResetCaptcha(captchaResponse: string) {
  //   this.passwordResetFG.get('captchaResponse').setValue(captchaResponse);
  // }
  // captchaRequest(event) {
  //   this.requestCaptchaKey = event.key;
  // }
}
